import React from "react";

import clsx from "clsx";
import { rem, transparentize } from "polished";
import styled, { css } from "styled-components";

import { useMountTransition } from "../../hooks/use-mount-transition";
import Portal from "../../hooks/use-portal";

const Button = ({
  children,
  onClick,
  className = "",
  variant = "",
  skin = "",
}) => {
  return (
    <ButtonLayout className="builder-button" variant={variant} skin={skin}>
      <button onClick={onClick} className={className}>
        <span>{children}</span>
      </button>
    </ButtonLayout>
  );
};
export default Button;

export const ButtonWrapper = styled.div`
  margin-top: 15px;
`;

const ButtonLayout = styled.div`
  ${({ theme, variant, skin }) => css`
    button {
      width: 100%;
      background-color: ${transparentize(0.91, theme.colors.black)};
      border: none;
      padding: 15px 0;
      cursor: pointer;
      position: relative;
      color: ${theme.colors.black};
      overflow: hidden;
      transition: 0.3s ease all;

      ${skin === "red" &&
      css`
        background-color: ${theme.colors.primary};
        color: ${theme.colors.white};

        &:hover {
          opacity: 0.9;
        }
      `}

      ${variant !== "normal" &&
      css`
        &::after {
          content: "";
          position: absolute;
          width: 100%;
          height: 100%;
          background-color: ${theme.colors.primary};
          top: 0;
          left: 0;
          pointer-events: none;
          transform: translateX(calc(100% - 22px)) skewX(-45deg);
          transition: 0.3s ease all;
        }

        &:hover {
          color: #fff;
          &::after {
            transform: translateX(22px) skewX(-45deg);
          }
        }
      `}

      span {
        position: relative;
        z-index: 1;
      }
    }
  `}
`;
